import { Twitter, Send, Instagram, Linkedin, Facebook, Youtube, Music2, MessageCircle, Phone } from "lucide-react";
import { useSettings } from "../context/SettingsContext";
import { BrandLogo } from "./BrandLogo";
import { SmartLink } from "./PublicHeader";

export const SOCIAL_ICONS = { twitter: Twitter, telegram: Send, instagram: Instagram, linkedin: Linkedin, facebook: Facebook, youtube: Youtube, tiktok: Music2, discord: MessageCircle, whatsapp: Phone };

const legacyLayout = (general) => ({
  footer_columns: [{ title: "Platform", links: [{ label: "About Us", url: "/about" }, { label: "Contact", url: "/contact" }, { label: "Get Started", url: "/register" }, { label: "Sign In", url: "/login" }] }],
  socials: ["twitter", "telegram", "instagram", "linkedin"].filter((k) => general[`social_${k}`]).map((k) => ({ platform: k, url: general[`social_${k}`] })),
  footer_description: general.description, copyright: general.copyright, footer_text: general.footer_text,
});

export default function PublicFooter({ layout: override, preview = false }) {
  const { general, layout: ctxLayout } = useSettings();
  const layout = override || ctxLayout || legacyLayout(general);
  const cols = layout.footer_columns || [];

  return (
    <footer className="bg-white border-t border-slate-200" data-testid={preview ? "preview-footer" : "public-footer"}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 gap-8 md:[grid-template-columns:var(--fcols)]" style={{ "--fcols": `2fr repeat(${Math.max(cols.length, 1)}, minmax(0, 1fr))` }}>
          <div className="col-span-2 md:col-span-1">
            <BrandLogo logoUrl={general.logo_url} siteName={general.site_name || "Fx Cloud"} textClass="text-slate-900" className="mb-4" />
            <p className="text-sm text-slate-600 max-w-sm leading-relaxed">{layout.footer_description}</p>
            {layout.socials?.length > 0 && (
              <div className="flex gap-3 mt-5" data-testid="footer-socials">
                {layout.socials.map((s, i) => {
                  const Icon = SOCIAL_ICONS[s.platform] || Send;
                  return (
                    <a key={i} href={s.url} target="_blank" rel="noreferrer" aria-label={s.platform} data-testid={`footer-social-${s.platform}`} className="h-9 w-9 rounded-lg bg-slate-100 hover:bg-blue-600 hover:text-white text-slate-600 grid place-items-center transition-colors">
                      <Icon className="h-4 w-4" />
                    </a>
                  );
                })}
              </div>
            )}
          </div>
          {cols.map((c, ci) => (
            <div key={ci} data-testid={`footer-col-${ci}`}>
              <h4 className="font-display font-bold text-slate-900 text-sm mb-3">{c.title}</h4>
              <ul className="space-y-2 text-sm text-slate-600">
                {c.links.map((l, li) => <li key={li}><SmartLink to={l.url} className="hover:text-blue-600">{l.label}</SmartLink></li>)}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-slate-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500" data-testid="footer-copyright">{layout.copyright}</p>
          <p className="text-xs text-slate-400 max-w-md text-center sm:text-right">{layout.footer_text}</p>
        </div>
      </div>
    </footer>
  );
}
